import React from 'react';

const TopBanner: React.FC = () => {
  const content = (
    <span className="inline-block mx-4 text-sm text-gray-600">
      A hackathon for builders, tinkerers, and toolmakers.
      Code fast. Share faster. → 
      <a 
        href="/hackathon/register" 
        className="text-blue-600 no-underline ml-2 font-medium hover:underline"
      >
        Register now{'    '}
      </a>
      <span className="inline-block mx-4 text-sm text-gray-600">
      We'd love to see what you've built. Enter for the chance to win cash prizes! → 
      <a 
        href="/hackathon/submit" 
        className="text-blue-600 no-underline ml-2 font-medium hover:underline"
      >
        Submit project
      </a>
      </span>
    </span>
  );

  return (
    <div className="w-full overflow-hidden bg-white border-b border-gray-200 py-2">
      <div 
        className="flex whitespace-nowrap"
        style={{
          animation: 'scroll 40s linear infinite',
          width: 'max-content'
        }}
      >
        {content}
        {content}
        {content}
        {content}
        {content}
        {content}
        {content}
        {content}
      </div>
    </div>
  );
};

export default TopBanner; 